import React from 'react';
import Navigation from '../components/Navigation/Navigation.jsx';
import PlaygroundHero from '../components/Playground/PlaygroundHero';
import PlaygroundCards from '../components/Playground/PlaygroundCards';
import Footer from '../components/Footer/Footer.jsx';

const Playground = () => {
    return (
        <>
            <Navigation page="playground" />
            <PlaygroundHero />
            <PlaygroundCards />
            <Footer />
        </>
    );
}

export default Playground;
